import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { use100vh } from "react-div-100vh";
import CircularProgress from "@material-ui/core/CircularProgress";
import mainTheme from "mainTheme";

import { usePrepareData } from "utils/usePrepareData";
import "moment/locale/de";
import Map from "map/MapPage";
import ControlBar from "controls/ControlBar";
import DateRange from "controls/DateRange";

import styled, { ThemeProvider } from "styled-components";
import useLocalStorage from "utils/useLocalStorage";

const MainWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  margin: 0 auto;
  flex-flow: column nowrap;
`;
const Overlay = styled.div`
  height: 100%;
  width: 100%;
  z-index: 2;
  position: absolute;
`;
export const Loading = styled.span`
  color: ${({ theme }) => theme.primaryColor};
  position: absolute;
  z-index: 5;
  bottom: 90px;
  left: 15px;
  font-size: 32px;
  font-weight: bold;
`;

function MainPage() {
  const {
    isLoading,
    today,
    dateRange,
    setDateRange,
    channels,
    filteredEvents,
    checkedOnlyFavs,
    savedLocation,
    setBounds,
    selectedChannels,
    toggleChannel,
    setCheckedOnlyFavs,
    query,
    setUpdateEvents,
    updateEvents,
    isLoadingEvents,
    reloadSavedLocation,
  } = usePrepareData();
  const [toggleModal, setToggleModal] = useState(0);
  const [openInfo, setOpenInfo] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const [selectedRoute, setSelectedRoute] = useLocalStorage("selectedRoute", []);
  const height100 = use100vh();

  return (
    <ThemeProvider theme={mainTheme}>
      <MainWrapper>
        {isLoading && !openInfo && (
          <Loading>
            <CircularProgress disableShrink color="inherit" />
          </Loading>
        )}
        {toggleModal !== 0 && <Overlay onClick={() => setToggleModal(0)} />}
        <ControlBar
          setSelectedCompany={setSelectedCompany}
          toggleModal={toggleModal}
          setToggleModal={setToggleModal}
          setSelectedRoute={setSelectedRoute}
          selectedRoute={selectedRoute}
          channels={channels}
          selectedChannels={selectedChannels}
          filteredEvents={filteredEvents}
          toggleChannel={toggleChannel}
          checkedOnlyFavs={checkedOnlyFavs}
          setCheckedOnlyFavs={setCheckedOnlyFavs}
          savedLocation={savedLocation}
          reloadSavedLocation={reloadSavedLocation}
          query={query}
          setUpdateEvents={setUpdateEvents}
          updateEvents={updateEvents}
          isLoading={isLoading}
          isLoadingEvents={isLoadingEvents}
        />
        <div style={{ height: height100 ? `${height100 - 85.5}px` : "100vh" }}>
          <Map
            selectedCompany={selectedCompany}
            openInfo={openInfo}
            setOpenInfo={setOpenInfo}
            channels={channels}
            filteredEvents={filteredEvents}
            checkedOnlyFavs={checkedOnlyFavs}
            setBounds={setBounds}
          />
        </div>
        <DateRange today={today} dateRange={dateRange} setDateRange={setDateRange} />
        <Outlet />
      </MainWrapper>
    </ThemeProvider>
  );
}

export default MainPage;
